import { Divider, Stack } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import StrategicPlanningItem from "./StrategicPlanningItem";

export default function StrategicPlanningFinder() {
    const { strategicPlannings } = useOutletContext();

    return (
        <Stack spacing={2} divider={<Divider />} sx={{ marginTop: 3 }}>
            {strategicPlannings.map((strategicPlanning) => (
                <StrategicPlanningItem key={strategicPlanning.id} strategicPlanning={strategicPlanning} />
            ))}
        </Stack>
    );
}
